const Default = ({ project }) => {
  return <h1>Loading ....</h1>;
};

export default Default;
